import gql from 'graphql-tag';

const UPDATE_SENSORS = gql`
  mutation Mutation($deviceSerialNo: String!, $sensors: [String]) {
    updateSensors(deviceSerialNo: $deviceSerialNo, sensors: $sensors) {
      code
    }
  }
`;

export default UPDATE_SENSORS;
